<template>
  <top-navigation-button
    v-for="(button, index) in visibleButtons"
    :key="index"
    :link-to="button.link"
    :icon="button.icon"
    :active="button.exact ? $route.path === button.link : $route.path.startsWith(button.link)"
  />
</template>

<script>
import {barbellSharp, barChartSharp, calendarSharp, fileTrayFullSharp, fitnessSharp, giftSharp, personSharp, pulseSharp, stopwatchSharp} from 'ionicons/icons';
import TopNavigationButton from './TopNavigationButton.vue';

export default {
    name: 'TopNavigationMainButtons',
    components: {
        TopNavigationButton,
    },
    data() {
        return {
            // requiredPermissions uses keys from PERMISSIONS mixin (see services/permissions.js)
            buttons: [
                {description: 'Übersicht', link: '/home', icon: pulseSharp, exact: true},
                {description: 'Terminverwaltung', link: '/appointments', icon: calendarSharp, requiredPermissions: ['EMPLOYEE', 'ACCOUNTING', 'OWNER']},
                {description: 'Profilmanagement', link: '/management', icon: personSharp},
                {description: 'Verordnungsmanagement', link: '/verordnungsservice', icon: fileTrayFullSharp, requiredPermissions: ['OWNER', 'ACCOUNTING']},
                {description: 'Rechnungsverwaltung', link: '/invoices', icon: barChartSharp, requiredPermissions: ['PATIENT', 'ACCOUNTING']},
                {description: 'Gutscheine', link: '/gutscheine', icon: giftSharp, requiredPermissions: ['OWNER', 'ACCOUNTING']},
                {description: 'Übungskatalog', link: '/uebungskatalog', icon: barbellSharp, requiredPermissions: ['EMPLOYEE', 'OWNER', 'ADMINISTRATION']},
                {description: 'Training', link: '/training', icon: stopwatchSharp, requiredPermissions: ['EMPLOYEE', 'OWNER', 'ADMINISTRATION']},
                {description: 'Meine Übungen', link: '/meine-uebungen', icon: fitnessSharp, requiredPermissions: ['PATIENT']},
                // {description: 'Abrechnungen', link: '/billing', icon: calculatorSharp, requiredPermissions: ['ACCOUNTING', 'OWNER']},
                // {description: 'Kasse', link: '/cash-register', icon: walletSharp, requiredPermissions: ['ACCOUNTING', 'OWNER']},
                // {description: 'Kommunikation', link: '/communication', icon: chatbubbleEllipsesSharp},
            ],
        };
    },
    computed: {
        visibleButtons() {
            return this.buttons.filter((button) => {
                if (!button.requiredPermissions || button.requiredPermissions.length === 0) {
                    return true;
                }
                return button.requiredPermissions.some((permissionKey) => {
                    const permissionValue = this.PERMISSIONS[permissionKey];
                    if (permissionValue === undefined) {
                        return false;
                    }
                    return this.hasPermission(permissionValue);
                });
            });
        },
    },
};
</script>
